import TextPage from "./TextPage.vue";
import DownloadPage from "./DownloadPage.vue";
import VideoPage from "./VideoPage.vue";
import ImagePage from "./ImagePage.vue";
import ChoicePage from "./ChoicePage.vue";
import ComparePage from "./ComparePage.vue";
import MultiChoicePage from "./MultiChoicePage.vue";
import ProgramPage from "./ProgramPage.vue";
import CompareHintPage from "./CompareHintPage.vue";

const pageMap = {
  text: TextPage,
  video: VideoPage,
  image: ImagePage,
  choice: ChoicePage,
  'multi-choice': MultiChoicePage,
  download: DownloadPage,
  compare: ComparePage,
  program: ProgramPage,
  hint: CompareHintPage
}

export {pageMap, TextPage, VideoPage, ChoicePage, MultiChoicePage, DownloadPage, ImagePage, ComparePage, ProgramPage}

